import React from 'react';
import { Result } from 'antd';
import PortalLayout from './PortalLayout';

export interface PortalErrorPageProps {
  variant?: 'expired' | 'not_found' | 'rate_limited' | 'unknown';
  shopName?: string;
}

const COPY: Record<NonNullable<PortalErrorPageProps['variant']>, { title: string; subtitle: string }> = {
  expired:      { title: 'This link has expired',    subtitle: 'Please contact the shop for a fresh link.' },
  not_found:    { title: 'Link not found',           subtitle: 'The link may be incorrect or have been revoked.' },
  rate_limited: { title: 'Too many requests',        subtitle: 'Please wait a minute and try again.' },
  unknown:      { title: 'Something went wrong',     subtitle: 'Please try again or contact the shop.' },
};

const PortalErrorPage: React.FC<PortalErrorPageProps> = ({ variant = 'unknown', shopName = 'CNF Auto' }) => {
  const copy = COPY[variant];
  return (
    <PortalLayout title=" " shopName={shopName}>
      <Result status="warning" title={copy.title} subTitle={copy.subtitle} />
    </PortalLayout>
  );
};

export default PortalErrorPage;
